import React, { FC, useState } from 'react'

import { CardWrapper } from '../CardWrapper/CardWrapper'
import { CardItem } from '../CardItem/CardItem'
import { CardEmpty } from '../../empty/CardEmpty/CardEmpty'

import { getMembershipDate, isExpiredMembership } from '../../../../../../helpers/requiredFields'
import { useProfile } from '../../../../../../hooks/useProfile'

import { IUserDocuments, IUserInterface } from '../../../../../../models/users/user.interface'

const getDefaultValue = (key: IUserDocuments | undefined) => {
  return `${key?.documentNumber}${key?.endDate && ` , ${getMembershipDate(key?.endDate)}`}`
}

interface UserMembershipsCardProps {
  user: IUserInterface | null
  setUser?: (state: IUserInterface) => void
  isCollapsible?: boolean
  isEditable?: boolean
}

export const UserMembershipsCard: FC<UserMembershipsCardProps> = ({
  user,
  setUser,
  isCollapsible,
  isEditable,
}) => {
  const { onSaveEditUser, onCancelEditUser, onChangeUserInput } = useProfile()

  const [isEdit, setIsEdit] = useState(false)

  if (!user) return <CardEmpty />

  return (
    <CardWrapper
      isCollapsible={isCollapsible}
      title="Memberships"
      onSaveEdit={() => onSaveEditUser({ user, setIsEdit })}
      onCancelEdit={() => onCancelEditUser({ user, setUser, setIsEdit })}
      isEditable={isEditable}
      isEdit={isEdit}
      setIsEdit={setIsEdit}
    >
      <CardItem
        label="USEF membership"
        fieldType="number"
        fieldKey="userUSEF"
        defaultValue={getDefaultValue(user.userUSEF)}
        url={user.userUSEF?.image}
        isInvalid={!user.userUSEF?.documentNumber || !user.userUSEF?.endDate}
        isMissing={!user.userUSEF?.documentNumber}
        isExpired={isExpiredMembership(user.userUSEF?.endDate)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeUserInput({ fieldName, fieldType, fieldKey, option, user, setUser })
        }
      />
      <CardItem
        label="FEI membership"
        fieldType="number"
        fieldKey="userFEI"
        defaultValue={getDefaultValue(user.userFEI)}
        url={user.userFEI?.image}
        isInvalid={!user.userFEI?.documentNumber || !user.userFEI?.endDate}
        isMissing={!user.userFEI?.documentNumber}
        isExpired={isExpiredMembership(user.userFEI?.endDate)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeUserInput({ fieldName, fieldType, fieldKey, option, user, setUser })
        }
      />
      <CardItem
        label="USDF membership"
        fieldType="number"
        fieldKey="userUSDF"
        defaultValue={getDefaultValue(user.userUSDF)}
        url={user.userUSDF?.image}
        isInvalid={!user.userUSDF?.documentNumber || !user.userUSDF?.endDate}
        isMissing={!user.userUSDF?.documentNumber}
        isExpired={isExpiredMembership(user.userUSDF?.endDate)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeUserInput({ fieldName, fieldType, fieldKey, option, user, setUser })
        }
      />
      <CardItem
        label="AHA membership"
        fieldType="number"
        fieldKey="userAHA"
        defaultValue={getDefaultValue(user.userAHA)}
        url={user.userAHA?.image}
        isInvalid={!user.userAHA?.documentNumber || !user.userAHA?.endDate}
        isMissing={!user.userAHA?.documentNumber}
        isExpired={isExpiredMembership(user.userAHA?.endDate)}
        showLabelError={true}
        isEdit={isEdit}
        onChange={({ fieldName, fieldType, fieldKey, option }) =>
          onChangeUserInput({ fieldName, fieldType, fieldKey, option, user, setUser })
        }
      />
    </CardWrapper>
  )
}
